import { Link } from 'react-router-dom';

export default function PunkteSpiele() {
  return (
    <div className="home-page">
      {/* Hero header */}
      <section style={{ width: '100vw', margin: 0, padding: 0, position: 'relative', left: '-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin: '0 0 8px' }}>
          Punkte-Spiele
        </h2>
        <p className="hero-desc" style={{ margin: '0 auto 24px', textAlign: 'center', maxWidth: 760 }}>
          Spiele mit deinem Punkte-Konto und sichere dir Belohnungen.
        </p>
      </section>

      {/* Centered content */}
      <section
        style={{
          width: '100%',
          maxWidth: 900,
          margin: '0 auto',
          padding: '0 16px 40px 16px',
          color: '#fff',
        }}
      >
        <div
          style={{
            margin: '0 0 14px',
            padding: 14,
            borderRadius: 14,
            border: '1px solid rgba(255,255,255,0.18)',
            background: 'rgba(0,0,0,0.35)',
            boxShadow: '0 10px 24px rgba(0,0,0,0.35)',
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 900, marginBottom: 6, color: 'rgba(255,255,255,0.98)' }}>
            Hinweis: Glücksspielelemente & Suchtgefahr
          </div>
          <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.5 }}>
            Diese Spiele enthalten Glücksspielelemente und Mechaniken mit Zufallsprinzip. Bitte spiele bewusst,
            mache Pausen und setze dir klare Grenzen.
            <br />
            Wenn du merkst, dass du die Kontrolle verlierst oder dir das Spielen nicht guttut, hol dir Hilfe – z.B.
            bei einer lokalen Suchtberatungsstelle, über ärztliche Anlaufstellen oder über seriöse Informations- und
            Hilfsangebote zum Thema Glücksspielsucht (z.B. „Check dein Spiel“).
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 14,
          }}
        >
          <Link
            to="/punkte-spiele/gluecksrad"
            style={{
              display: 'block',
              textDecoration: 'none',
              color: '#fff',
              borderRadius: 14,
              border: '1px solid rgba(255,255,255,0.18)',
              background: 'rgba(0,0,0,0.35)',
              boxShadow: '0 10px 24px rgba(0,0,0,0.35)',
              padding: 14,
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 900, marginBottom: 6 }}>
              ⭐ Glücksrad
            </div>
            <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.4 }}>
              Drehe täglich am Rad und erhalte zufällige Gewinne.
            </div>
          </Link>

          <Link
            to="/punkte-spiele/einarmiger-bandit"
            style={{
              display: 'block',
              textDecoration: 'none',
              color: '#fff',
              borderRadius: 14,
              border: '1px solid rgba(255,255,255,0.18)',
              background: 'rgba(0,0,0,0.35)',
              boxShadow: '0 10px 24px rgba(0,0,0,0.35)',
              padding: 14,
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 900, marginBottom: 6 }}>
              🎰 Einarmiger Bandit
            </div>
            <div style={{ fontSize: 12, color: '#ccc', lineHeight: 1.4 }}>
              Dreh an den Walzen und erhalte zufällige Gewinne.
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
}
